import React from 'react';
import BreadcrumbNoMask from '../BreadcrumbNoMask';

function CollectionInfoHeader({
  collectionId,
  symbol = '',
    name = '',
  contractAddress = null,
  network,
  className = '',
    image = '',
  totalSupply = null,
  chainId = null,
  numHolders = null,
}) {
  // Keep the prose in sync with the figure shown in the stat card.
  const desc = totalSupply !== null && totalSupply !== undefined
    ? `This is a collection of NFTs. There are ${totalSupply} in total and it is sick blud. Please mint one right away, or we will be back.`
    : "This is a collection of NFTs. Please mint one right away, or we will be back.";
  return (
    <div className={`glass-banner mt-2 ${className}`}>
      <BreadcrumbNoMask
        image={image}
        text1={symbol || ''}
        text2={contractAddress}
        text3={name}
        colldesc={desc}
        items={totalSupply}
        chainId={chainId}
        numHolders={numHolders}
        net={collectionId && network ? {
          png: `/netpng/${network}.png`,
          alt: network
        } : null}
      />
    </div>
  );
}

export default CollectionInfoHeader;
